import { ConfigurationBillableConceptGroupResponse } from '@/modules/configurationModule/detail/accounting/billable/groups-of-concepts/services/configuration-billable-concept-group.dto'
import { Nullable } from '@/shared/types/app.types'

export interface ConfigurationBillableConceptsModalState {
    id: Nullable<number>
    name: string
    code: string
    active: boolean
    group: Nullable<ConfigurationBillableConceptGroupResponse>
    conceptGroups: ConfigurationBillableConceptGroupResponse[]
}
export const initialConfigurationBillableConceptsModalState =
    (): ConfigurationBillableConceptsModalState => ({
        id: null,
        name: '',
        code: '',
        active: true,
        group: null,
        conceptGroups: []
    })
